export default "__VITE_ASSET__BYxdaXeI__"